import React from "react";
import { Button } from "@mantine/core";
import { useHistory } from "react-router-dom";
import PageShell from "../../components/UI/PageShell";

const ThankyouPage = () => {
  const history = useHistory();

  return (
    <PageShell title="Feedback sent" eyebrow="Thank you" description="Your feedback has been submitted successfully." backTo={null}>
      <div className="portal-empty-state">
        <span className="portal-empty-state__icon" aria-hidden="true"><i className="fas fa-check" /></span>
        <h2>Thank you!</h2>
        <p>We appreciate you sending us your feedback.</p>
      <Button
        onClick={() => history.push("/")}
        radius="md"
        size="md"
        className="btn btn-design btn-brand mt-3"
      >
        Home
      </Button>
      </div>
    </PageShell>
  );
};

export default ThankyouPage;
